export const LIST_EVENTS_SHOW_EDIT_POPUP = 'LIST_EVENTS_SHOW_EDIT_POPUP';
export const LIST_EVENTS_SHOW_CREATE_POPUP = 'LIST_EVENTS_SHOW_CREATE_POPUP';

export const LIST_EVENTS_HIDE_ALL_POPUPS = 'LIST_EVENTS_HIDE_ALL_POPUPS';

export const REQUEST_EVENT_TYPE_USAGE = 'REQUEST_EVENT_TYPE_USAGE';
export const RECEIVE_EVENT_TYPE_USAGE = 'RECEIVE_EVENT_TYPE_USAGE';
export const RECEIVE_EVENT_TYPE_USAGE_ERROR = 'RECEIVE_EVENT_TYPE_USAGE_ERROR';
